/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

  export function meevoPhoneNumberFilter(): angular.IFilterService {
    const filter = (input: any, param?: any) => {

      if (!input) {
        return "";
      }

      var value = input.toString().trim().replace(/[+-]/g, "");
      var country: string;
      var city: string;
      var lineNumber: string;
      var isFullNumber = param && param.fullNumber

      switch (value.length) {
      case 10: // +1PPP####### -> C (PPP) ###-####
        country = "1";
        city = value.slice(0, 3);
        lineNumber = value.slice(3);
        break;

      case 11: // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        lineNumber = value.slice(4);
        break;

      case 12: // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        lineNumber = value.slice(5);
        break;

      default:
          return input;
      }

      lineNumber = lineNumber.slice(0, 3) + "-" + lineNumber.slice(3);

      if (isFullNumber) {
        return ('+' + country + " (" + city + ") " + lineNumber).trim();
      }

      if (country === "1") {
        country = "";
      }

      return (country + " (" + city + ") " + lineNumber).trim();
    };
    return filter;
  }


  angular.module("meevo.components.filters")
    .filter("meevoPhoneNumber", meevoPhoneNumberFilter);
}
